import { Component, Input, OnInit } from '@angular/core';
import { ProductModel } from 'src/app/models/wardrobe.model';
import {InAppService, Product, PurchaseEventType, VerifiedReceipt} from 'src/app/services/in-app.service';
import { TranslateService } from '@ngx-translate/core';
import {finalize, switchMap} from 'rxjs/operators';
import { BasePage } from 'src/app/pages/base.page';
import { Platform } from '@ionic/angular';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { inAppProducts } from 'src/environments/environment';
import { ModalController } from '@ionic/angular';
import {EMPTY, from} from "rxjs";
import {ChatService} from "../../services/chat.service";
import {Router} from "@angular/router";
import {marker} from "@biesbjerg/ngx-translate-extract-marker";

@Component({
  selector: 'app-swap-request-payment-modal',
  templateUrl: './swap-request-payment-modal.component.html',
  styleUrls: ['./swap-request-payment-modal.component.scss'],
})
export class SwapRequestPaymentModalComponent implements OnInit {
  chatProduct: Product;
  @Input() product: ProductModel;
  @Input() page: BasePage;

  constructor(
    public inAppService: InAppService,
    protected translate: TranslateService,
    protected platform: Platform,
    private errorService: ErrorHandlerService,
    private modalCtrl: ModalController,
    private chatService: ChatService,
    private router: Router
    ) {}

  ngOnInit() {
    this.chatProduct = this.inAppService.products.find((product) => product.id == inAppProducts.CHAT_FEE_CONSUMABLE);

    console.log(this.product, 'PRODUCT');
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  chatRequest(receipt: VerifiedReceipt | CdvPurchase.VerifiedReceipt) {
    this.chatService.sendChatRequest({ p_id: this.product?.id })
      .subscribe((res) => {
        if (receipt instanceof CdvPurchase.VerifiedReceipt) {
          receipt.finish().catch((reason) => console.warn("Finish failed", reason));
        }
        this.router.navigate(['chat', res?.id]);
        this.closeModal();
        this.page.showToast(this.translate.instant('Otp.success', { user: this.product.user.name }));
        }, error => {
          this.errorService.handle(error);
        });
  }

  payForSwapRequest(product: Product = this.chatProduct){
    if (!product || !product.canPurchase) {
      this.errorService.showToast(
        this.translate.instant('IAP.PurchaseUnavailable')
      );
      return;
    }

    if (this.inAppService.isPurchasing) {
      this.errorService.showToast(
        this.translate.instant('IAP.PurchaseInProgress')
      );

      return;
    }

    return from(this.page.showLoader())
      .pipe(
        switchMap(() => {
          if (product.owned) {
            this.errorService.showToast(
              this.translate.instant('Subscription.AlreadySubscribed')
            );
            return EMPTY;
          }

          return this.inAppService.handleSubscription(product.id);
        }),
        finalize(() => this.page.hideLoader())
      )
      .subscribe({
        next: (event) => {
          switch (event.event) {
            case PurchaseEventType.ERROR: {
              this.errorService.handleIapError(event.error);
              break;
            }
            case PurchaseEventType.FINISHED: {
              this.page.hideLoader();
              console.log("Product is finished.")
              break;
            }
            case PurchaseEventType.VERIFIED: {
              this.chatRequest(event.verifiedReceipt);
              console.log("Product is verified.")
              break;
            }
            case PurchaseEventType.UNVERIFIED: {
              if (this.platform.is('ios')) {
                this.errorService.showToast(
                  this.translate.instant(
                    'Subscription.Purchase.ValidationFailed.Apple'
                  )
                );
              } else {
                this.errorService.showToast(
                  this.translate.instant(
                    'Subscription.Purchase.ValidationFailed.Google'
                  )
                );
              }

              break;
            }
          }
        },
        error: (error: unknown) => {
          console.warn('purchase error', error);

          this.errorService.handle(error);
        },
      });
  }
}
